import AppDescription from '@nxsys/components/AppDescription';
import { autoEnrolmentSchemeTypeIrelandOptions } from '@nxsys/constants/AppConst';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { ICompany } from '@nxsys/types/models/company';
import { Descriptions } from 'antd';

type Props = {
  data?: ICompany;
};

const AutoEnrolmentSettings: React.FC<Props> = () => {
  const { messages } = useTypedIntl();

  return (
    <div className="AutoEnrolmentSettings">
      <AppDescription
        column={1}
        labelStyle={{ width: 316 }}
        bordered={false}
        colon={false}
        size="middle"
      >
        <Descriptions.Item
          label={messages['common.typeOfScheme']}
        >
          {autoEnrolmentSchemeTypeIrelandOptions[0].label || '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={messages['common.defaultEmployeeContribution']}
        >
          {'1.5%'}
        </Descriptions.Item>
        <Descriptions.Item
          label={messages['common.defaultEmployerContribution']}
        >
          {'1.5%'}
        </Descriptions.Item>
      </AppDescription>
    </div>
  );
};

export default AutoEnrolmentSettings;
